import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { pillarArticles } from '@/mocks/articles';

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section id="articles" className="bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="font-heading text-2xl md:text-4xl font-bold tracking-tight text-foreground-950">
            {t('pillar.title')}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            {t('pillar.subtitle')}
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {pillarArticles.map((article) => (
            <Link
              key={article.key}
              to={article.href}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={article.image}
                  alt={t(`pillar.${article.key}.title`)}
                  title={`${t(`pillar.${article.key}.title`)} USFans`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                  {t(`pillar.${article.key}.title`)}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  {t(`pillar.${article.key}.excerpt`)}
                </p>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600 group-hover:text-primary-700 transition-colors">
                  {t('pillar.read')}
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}